import type { DirectorProfile, Fan } from '@clutch/core';

export function defaultProfile(fan?: Pick<Fan, 'team' | 'player' | 'directorProfile'>): DirectorProfile {
  if (fan?.directorProfile) return structuredClone(fan.directorProfile);
  return { followedTeams: fan?.team ? [fan.team] : [], followedPlayers: fan?.player ? [fan.player] : [], language: 'en', familiarity: 'regular' };
}

/** An explicitly empty stored profile is an answer, not permission to restore legacy interests. */
export function interests(profile: DirectorProfile | undefined, fan: Pick<Fan, 'team' | 'player' | 'directorProfile'>) {
  const p = profile ?? defaultProfile(fan);
  return { teams: p.followedTeams, players: p.followedPlayers };
}

export function parsePlayers(value: string): string[] {
  const names = value.split(/[,，]/).map((s) => s.trim()).filter(Boolean);
  if (names.some((s) => s.length > 80)) throw new Error('Keep each player name under 81 characters.');
  const unique = names.filter((name, index) => names.findIndex((n) => n.toLocaleLowerCase() === name.toLocaleLowerCase()) === index);
  if (unique.length > 20) throw new Error('Follow up to 20 players.');
  return unique;
}

/** Serialize writes so the last selected language is also the last persisted one. */
export class ProfileWriter {
  private tail: Promise<unknown> = Promise.resolve();
  constructor(private readonly save: (patch: Partial<DirectorProfile>) => Promise<DirectorProfile>) {}
  write(patch: Partial<DirectorProfile>) {
    const captured = structuredClone(patch);
    const result = this.tail.then(() => this.save(captured));
    this.tail = result.catch(() => undefined);
    return result;
  }
}
